module.exports = __webpack_public_path__ + "mastercard.png";